<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import NervenetFrame from './NervenetFrame.vue';

const { accountId } = useAccount();

const kbSearchUrl = computed(
  () =>
    `${window.chatwootConfig.nervenetBaseUrl}/accounts/${accountId.value}/agent/kb_search`
);
</script>

<template>
  <NervenetFrame :src="kbSearchUrl" />
</template>
